import { toast } from "react-toastify";
import {
  fetchCreateSubCategoryRequest,
  fetchCreateSubCategorySuccess,
  fetchCreateSubCategoryFailure,
} from "./reducer";
import { determineBaseUrlAndPerformApiCall } from "../../interceptor/interceptor";
import { setSuccessMessage } from "../../toastMessage/action";
import { CREATE_SUBCATEGORY } from "../../constants/constants";

export const createSubCategory =
  (
    payload,
    pathArray,
    setLoading,
    callBack = () => {}
  ) =>
  async (dispatch) => {

    dispatch(fetchCreateSubCategoryRequest());
    setLoading(true);
    await determineBaseUrlAndPerformApiCall(
      CREATE_SUBCATEGORY(...pathArray),
      "POST",
      payload
    )
      .then((response) => {
        if (response.error) {
          dispatch(
            fetchCreateSubCategoryFailure(response.error.message)
          );
          toast.error(response.error.message);
          callBack();
        } else {
          dispatch(fetchCreateSubCategorySuccess(response));
          dispatch(setSuccessMessage(true));
          toast.success("Sub Category Created Successfully");
          callBack();
        }
      })

      .catch((error) => {
        dispatch(
          fetchCreateSubCategoryFailure(error.message)
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };